<template>
    <div class="row justify-content-left">
        <div class="col-md-12">
            <ol class="breadcrumb">
                <li class="breadcrumb-item" v-for="(breadcrumb, i) in getBreadcrumbParents"
                    :class="{active:i===getBreadcrumbParents.length-1}">
                    <a :href='regionRelativeUrl(breadcrumbUrl(breadcrumb))'
                       @click="changeUrl()">{{ breadcrumb.name }}</a>
                </li>

                <li class="breadcrumb-item"
                    v-if="!isCountryArea(user.breadcrumbs) && isBreadcrumbCategoryPublic(user.breadcrumbs.publicCategories, categoryPath)">
                    <a :href='regionRelativeUrl(breadcrumbUrl(user.breadcrumbs))'
                       @click="changeUrl()">
                        {{ user.breadcrumbs.german_name }}
                    </a>
                </li>

                <li class="breadcrumb-item">
                    {{ user.username }}
                </li>
            </ol>
        </div>
    </div>
</template>

<script>
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import {breadcrumbUrl} from "@/core/utils/helpers/breadcrumbs/breadcrumbUrlHelper";

function getCategoryUrlFromUrl() {
    /** pathname is set on backend so SSR could access profile path while window is undefined */
    const currentPath = _.get(this, 'user.pathname', (typeof window === 'undefined' ? '' : window.location.pathname));
    let pathName = this.pathWithoutRegion(currentPath).split('/');

    pathName.shift();
    pathName.pop();

    if (pathName.length > 1) {
        const seoUrls = [];
        _.forEach(this.settings.filter, (filter) => {
            seoUrls.push(_.trim(filter.url, '/'));
        })

        const pathNameString = pathName.join('/');

        if (seoUrls.includes(pathNameString)) {
            return pathNameString;
        }

        pathName.pop();
    }

    pathName.pop();

    pathName = pathName.join('/');

    if (pathName === 'bordelle') {
        pathName = this.settings.defaultCategorySlug;
    }

    return pathName;
}

function changeUrl() {
    $store.commit('setLoading', true);
}

function isBreadcrumbCategoryPublic(publicCategories, categoryPath) {
    if (!publicCategories || !publicCategories.length) {
        return false;
    }

    return !!_.find(publicCategories, (category) => category.path === categoryPath);
}

/**
 * Profiles located in the country area itself (e.g. nationwide agencies) must not
 * render the area crumb — it would duplicate the synthetic country crumb.
 */
function isCountryArea(breadcrumbs) {
    const areaNames = [breadcrumbs.german_name, breadcrumbs.display_name, breadcrumbs.english_name];

    return areaNames.includes(this.countryName)
        || (!!this.countryNameShort && areaNames.includes(this.countryNameShort));
}

export default {
    props: ['user'],
    computed: {
        categoryPath() {
            return `/${this.getCategoryUrlFromUrl()}/`;
        },
        countryDisplayName() {
            return this.countryNameShort || this.countryName;
        },
        countryBreadcrumb() {
            let url;

            if (this.categoryPath === `/${this.settings.defaultCategorySlug}/`) {
                url = this.settings.defaultSearchUrl;
            } else {
                url = this.categoryPath;
            }

            return {
                name: this.countryDisplayName,
                slug: '',
                url,
            };
        },
        getBreadcrumbParents() {
            let parents = _.reverse(_.cloneDeep(_.get(this, 'user.breadcrumbs.parent', [])));

            if (parents.length) {
                parents = _.filter(parents, (p) => isBreadcrumbCategoryPublic(p.publicCategories, this.categoryPath));
                parents.unshift(this.countryBreadcrumb);
                return parents;
            }

            return [this.countryBreadcrumb];
        },
        ...mapState([
            'settings',
            'countryName',
            'countryNameShort',
        ]),
    },
    mixins: [regionsUrlMixin],
    methods: {
        getCategoryUrlFromUrl,
        isBreadcrumbCategoryPublic,
        isCountryArea,
        changeUrl,
        breadcrumbUrl(item) {
            return breadcrumbUrl(item, this.categoryPath);
        },
    },
}
</script>
